export default __webpack_public_path__ + "static/search-expanded-ee8031f8204488c2bf5b3350eb65d8c9.png";